import { findDeepGetTask } from '../../GanttVisualization.helper';
import { getIsOdd } from '../common/validators';
import { weightTemplate } from './template';

const renderWeight = ({ task, column, t }) => {
  const gantt = window.ganttVisualization;
  if (task?.is_milestone) return '';

  const taskFromLookahead = findDeepGetTask(window.activities, 'id', task.id);
  if (!taskFromLookahead) return '';
  const isOdd = getIsOdd({ gantt, task }, column.name);

  return `<div class=${isOdd ? 'odd-col' : 'non-odd-col'}>
        ${weightTemplate(taskFromLookahead, t)}
    </div>`;
};

export default renderWeight;
